module.exports = __webpack_public_path__ + "img/559e72a.jpg";